var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReactivateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75323 9C9.75323 9.45 9.45379 9.75 9.00463 9.75C8.55548 9.75 8.25604 9.45 8.25604 9V1.5C8.25604 1.05 8.55548 0.75 9.00463 0.75C9.45379 0.75 9.75323 1.05 9.75323 1.5V9ZM9.00463 17.25C10.951 17.25 12.8225 16.5 14.3196 15.075C17.2391 12.15 17.2391 7.35 14.2448 4.425C13.9453 4.125 13.4962 4.125 13.1967 4.425C12.8973 4.725 12.8973 5.175 13.1967 5.475C15.5174 7.8 15.5174 11.625 13.1967 13.95C10.8761 16.275 7.0583 16.275 4.73766 13.95C2.41702 11.625 2.41702 7.8 4.73766 5.475C5.0371 5.175 5.0371 4.725 4.73766 4.425C4.43822 4.125 3.98907 4.125 3.68963 4.425C0.770123 7.35 0.770123 12.15 3.68963 15.075C5.18682 16.5 7.0583 17.25 9.00463 17.25Z",
    fill: "#419364"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8857_60010",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 16,
    height: 18
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75323 9C9.75323 9.45 9.45379 9.75 9.00463 9.75C8.55548 9.75 8.25604 9.45 8.25604 9V1.5C8.25604 1.05 8.55548 0.75 9.00463 0.75C9.45379 0.75 9.75323 1.05 9.75323 1.5V9ZM9.00463 17.25C10.951 17.25 12.8225 16.5 14.3196 15.075C17.2391 12.15 17.2391 7.35 14.2448 4.425C13.9453 4.125 13.4962 4.125 13.1967 4.425C12.8973 4.725 12.8973 5.175 13.1967 5.475C15.5174 7.8 15.5174 11.625 13.1967 13.95C10.8761 16.275 7.0583 16.275 4.73766 13.95C2.41702 11.625 2.41702 7.8 4.73766 5.475C5.0371 5.175 5.0371 4.725 4.73766 4.425C4.43822 4.125 3.98907 4.125 3.68963 4.425C0.770123 7.35 0.770123 12.15 3.68963 15.075C5.18682 16.5 7.0583 17.25 9.00463 17.25Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8857_60010)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H18V18H0V0Z",
    fill: "#419364"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReactivateIcon);
export default __webpack_public_path__ + "static/media/ReactivateIcon.dd42ee513fa9c219d90498be5facdaae.svg";
export { ForwardRef as ReactComponent };